import {
  get,
  isFunction,
  isEmpty,
  isObject,
  merge,
  map,
  isUndefined,
  unset,
  clone,
} from "utils/lodash";
interface TypeRouteStore {
  getBreadcrumbs: (ruleName: string, value?: any) => any;
  getOptions: (ruleName: string, value?: any) => any;
  addRule: (ruleName: string, value: any) => void;
  getUrl: (ruleName: string, params?: object) => string;
  [key: string]: any;
  //   parseUrl: (slug: string) => any;
}
import qs from "qs";
interface TypeGetRouteStore {
  (): TypeRouteStore;
}
export const helper = {
  url: (ruleName: string, params?: any) => {
    const result = {
      url: `/${ruleName}`,
      breadcrumbs: get(params, "breadcrumbs") || [],
    };
    if (isEmpty(ruleName)) return result;
    if (!!get(params, "slug")) {
      result.url = `/${ruleName}/${get(params, "slug")}`;
    }
    if (!!get(params, "id")) {
      result.url = `/${ruleName}/${get(params, "id")}`;
    }
    return result;
  },
};
interface IConfig {
  url?: (params: { [key: string]: any }) => any;
  breadcrumbs?: (params: { [key: string]: any }) => any;
  options: { [key: string]: any };
}
const mergeParams = (currParams: any, params: any) => {
  const rtn = merge(currParams, params);
  // unset
  map(params, (val, key) => {
    if (isUndefined(val)) {
      unset(rtn, key);
    }
  });
  return rtn;
};
const getRouteStore: TypeGetRouteStore = () => {
  const store: { [key: string]: any } = {};
  let params = {};
  let options = {};
  let pathname = "";

  const routeStore = {
    addRule: (ruleName: string, config: { [key: string]: any } = {}) => {
      if (!config?.url)
        config.url = (params: any) => helper.url(ruleName, params);
      store[ruleName] = config;
    },
    getUrl: (ruleName: string, params?: object) => {
      const rule = get(store, ruleName);
      if (rule && isFunction(rule.url)) {
        return get(rule.url(params), "url");
      }
      throw Error(`Rulename '${ruleName}' is not found`);
    },
    getOptions: (ruleName: string) => {
      const rule = get(store, ruleName);
      if (rule && isObject(rule.options)) {
        return rule.options;
      }
      throw Error(`Rulename '${ruleName}' is not found`);
    },
    getBreadcrumbs: (ruleName: string, params?: object) => {
      const rule = get(store, ruleName);
      if (rule && isFunction(rule.breadcrumbs)) {
        return get(rule.breadcrumbs(params), "breadcrumbs");
      }
      throw Error(`Breadcrumb '${ruleName}' is not found`);
    },
    setRedirect: ({ pathname: iPath, params: iPars, options: iOpts }: any) => {
      pathname = iPath;
      params = mergeParams(params, iPars || {});
      options = mergeParams(options, iOpts || {});
    },
    getRedirect: () => {
      return {
        pathname: clone(pathname),
        params: clone(params),
        options: clone(options),
      };
    },
    resetRedirect: () => {
      pathname = "";
      params = {};
      options = {};
    },
    mergeParams,
    setParams: (values: any) => {
      params = mergeParams(params, values);
    },
    getParams: () => {
      return clone(params);
    },
  };

  return routeStore;
};

export const routeStore = getRouteStore();

export default routeStore;
